import { useEffect, useState } from "react";
import { getData } from "../utils/apiCalls";
import { CarouselSlider } from './CarouselSlider';
import testimonials from '../data/testemonials_home.json'

export const TestimonialCarousel = ({ pageName }) => {
   const [data, setData] = useState(testimonials);

   // useEffect(() => {
   //    getData('https://youngstartup.io/api/cwebsite/get_testimonials?page=' + pageName)
   //       .then(res => {
   //          setData(res);
   //       })
   // }, [pageName]);

   return (
      <div className="testimonial-carousel">
         <CarouselSlider data={data} >
            {
               data.map((item, index) => (
                  <div key={index} className='testimonial-slide'>
                     <section className='person'>
                        <img className='round' src={item.image_url} alt={item.image_url} />
                        <h5>{item.name}</h5>
                        <h6>{item.company}</h6>
                     </section>
                     <section className="testimonial">
                        <h1>"{item.content}"</h1>
                     </section>
                  </div>
               ))
            }
         </CarouselSlider>
      </div>
   );
};
